import { Component, Inject, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { AuthService } from '@app/common/services/auth.service';
import { ComponentModel } from '@app/common/models/component.model';
import { DialogService } from '@app/common/services/dialog.service';
import { Restangular } from 'ngx-restangular';
import * as _ from 'lodash';
import { UserNamePipe } from '@app/common/pipes/username.pipe';
import { AttachmentTypePipe } from '@app/common/pipes/attachment-type.pipe';
import { ErrorHandlerService } from '@app/common/services/error-handler.service';
import { UploadService } from '@app/common/services/upload.service';
import { APP_CONFIG } from '@app/common/services/config.service';
import { DocumentsBaseComponent } from '@app/common/components/documents-base/document-base.component';

@Component({
  selector: 'gmt-components',
  templateUrl: './components.component.html',
  styleUrls: ['./components.component.scss']
})
export class ComponentsComponent extends DocumentsBaseComponent implements OnInit, OnChanges {

  components: ComponentModel[] = [];

  constructor(
    authService: AuthService,
    dialogService: DialogService,
    restangular: Restangular,
    usernamePipe: UserNamePipe,
    attachmentTypePipe: AttachmentTypePipe,
    errorHandlerService: ErrorHandlerService,
    uploadService: UploadService,
    @Inject(APP_CONFIG) config,
  ) {
    super(authService, dialogService, restangular, usernamePipe, attachmentTypePipe, errorHandlerService, uploadService, config);
    this.onUpdateComponent = this.onUpdateComponent.bind(this);
  }

  ngOnInit() {
    super.ngOnInit();
    this.documentsToComponents();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['documentList']) {
      this.documentsToComponents();
      this.componentSort();
    }
  }

  onComponentSort(sortBy: string) {
    this.componentSortOrder.direction = sortBy === this.componentSortOrder.sortBy
      ? this.componentSortOrder.direction === 'asc' ? 'desc' : 'asc'
      : 'asc';
    this.componentSortOrder.sortBy = sortBy;
    this.componentSort();
  }

  private componentSort() {
    this.components = _.orderBy(
      this.components,
      this.getComponentSortFunction(this.componentSortOrder.sortBy),
      this.componentSortOrder.direction as any
    );
  }

  private documentsToComponents() {
    this.components = this.documentList.list.reduce(
      (result, item) => result.concat(item.components),
      []
    );
  }
}
